export default "__VITE_ASSET__Cj1iHrg9__"